import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5205526f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ImageComponent/index.vue').default,LinkMail: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkMail/index.vue').default,LinkPhone: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkPhone/index.vue').default,LinkSite: require('/srv/rir-platform/tourism/src/tourism-front/components/common/LinkSite/index.vue').default,SocialsSquaredComponent: require('/srv/rir-platform/tourism/src/tourism-front/components/common/SocialsSquaredComponent/index.vue').default})
